import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';

export default function ChampionsForum() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MARKETING_CHAMPIONS_FORUM,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Champions Forum | Elevating the Christian Financial Industry</title>
                <meta name="description" content="Elevate your leadership in the Christian financial industry at the Champions Forum. Join industry champions & discover innovative values-aligned advice." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--get-certified'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

ChampionsForum.getLayout = page => <>{page}</>;
ChampionsForum.isPublic = true;
